import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import FontIcon from 'app/components/FontIcon/FontIcon';
export const DraggingItem = () => {
    return (_jsxs(Box, { sx: {
            bgcolor: 'lightgrey',
            height: '40px',
            width: '200px',
            cursor: 'grabbing',
            opacity: '.7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }, children: [_jsx(FontIcon, { icon: "fas-grip-vertical", className: "marginRight10", style: { color: 'rgb(178, 185, 199)' } }), "Drop widget on target"] }));
};
